import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'orderBy',
})
export class OrderByPipe implements PipeTransform {
  transform(value: any[], property: string): any[] {
    if (!value || !Array.isArray(value)) {
      return value;
    }

    return value.sort((a, b) => {
      if (a[property] < b[property]) {
        return -1;
      } else if (a[property] > b[property]) {
        return 1;
      } else {
        return 0;
      }
    });
  }
}
